import Dexie, { EntityTable } from 'dexie';

class AppDexieDatabase extends Dexie {
	public WEATHERDATA!: EntityTable<WeatherReduxType>;

	public constructor() {
		super('AppDatabase');
		this.version(1).stores({
			WEATHERDATA: 'id, date, temperature, humidity, windSpeed',
		});
	}
}

const Dbs = new AppDexieDatabase();

export default Dbs;
